<template>
  <card :active-index="0">
    <div class="row">
      <div class="col-sm-10 d-flex align-content-center justify-content-between">
        <div class="">
          <div>
            <p class="h5 mb-0">Nombre</p>
            <p>{{ plot.name }}</p>
          </div>
        </div>

        <div class="">
          <div>
            <p class="h5 mb-0">Productor</p>
            <router-link
              v-if="$can('show', 'producers')"
              :to="{ name: 'ProducerShow', params: { id: plot.field.producer.id } }"
            >
              <p class="font-weight-600">
                {{ plot.field.producer.businessName }}
              </p>
            </router-link>
            <p v-else class="font-weight-600">
              {{ plot.field.producer.businessName }}
            </p>
          </div>
        </div>

        <div class="">
          <div>
            <p class="h5 mb-0">Distribuidor</p>
            <router-link
              v-if="$can('show', 'distributors')"
              :to="{ name: 'DistributorShow', params: { id: plot.field.producer.distributor.id } }"
            >
              <p class="font-weight-600">
                {{ plot.field.producer.distributor.name }}
              </p>
            </router-link>
            <p v-else class="font-weight-600">
              {{ plot.field.producer.distributor.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
export default {
  props: {
    plot: {
      type: Object,
      required: true,
    },
  },
};
</script>
